import { render } from "./zhifubaoPay.vue?vue&type=template&id=07314b69&scoped=true"
import script from "./zhifubaoPay.vue?vue&type=script&lang=js"
export * from "./zhifubaoPay.vue?vue&type=script&lang=js"

import "./zhifubaoPay.vue?vue&type=style&index=0&id=07314b69&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-07314b69"

export default script